import { render } from "./MoveFileOverlay.vue?vue&type=template&id=ea984fa4"
import script from "./MoveFileOverlay.vue?vue&type=script&lang=js"
export * from "./MoveFileOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__